import { render, staticRenderFns } from "./ConfigOverlay.vue?vue&type=template&id=0ccc81ac&scoped=true&"
import script from "./ConfigOverlay.vue?vue&type=script&lang=js&"
export * from "./ConfigOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ConfigOverlay.vue?vue&type=style&index=0&id=0ccc81ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccc81ac",
  null
  
)

export default component.exports